import React from 'react'
import Navbar from '../components/Navbar'
import ProductInfo from '../components/ProductInfo'
import Footer from '../components/Footer'

function ProductDesc() {
  return (
    <div>
      <Navbar/>
      <ProductInfo/>
      <Footer/>
    </div>
  )
}

export default ProductDesc
